import React, { useState } from 'react';
import { Box, Typography, TextField, Button, IconButton } from '@mui/material';
import { Edit, Check, Close } from '@mui/icons-material';

interface EditableDescriptionProps {
  description: string;
  isOwner: boolean;
  onSave: (newDescription: string) => Promise<void>;
}

const EditableDescription: React.FC<EditableDescriptionProps> = ({ description, isOwner, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(description);
  const [saving, setSaving] = useState(false);

  if (!isOwner && !description) return null;

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(value);
      setEditing(false);
    } finally {
      setSaving(false);
    }
  };

  if (editing) {
    return (
      <Box sx={{ mt: 2 }}>
        <TextField
          fullWidth multiline minRows={2} maxRows={6}
          value={value} onChange={(e) => setValue(e.target.value)}
          placeholder="Add a description for your outfit…" size="small"
        />
        <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
          <Button size="small" startIcon={<Check />} onClick={handleSave} disabled={saving} variant="contained">Save</Button>
          <Button size="small" startIcon={<Close />} onClick={() => { setEditing(false); setValue(description); }}>Cancel</Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 2 }}>
      {description && <Typography variant="body1" sx={{ mb: 1 }}>{description}</Typography>}
      {isOwner && (
        <IconButton size="small" onClick={() => setEditing(true)} title="Edit description">
          <Edit fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default EditableDescription;
